import { Link } from 'react-router-dom';

export default function EventCard({img, name, description, date, timings}) {
    
    return (<>
        <div className="event-card">
            <div className="event-card-title">
                {name}
            </div>
            <div className="event-poster">
                <img src={img} alt='https://cdn.vectorstock.com/i/preview-1x/76/49/binary-code-digital-technology-background-vector-25687649.jpg' />
            </div>
            <div className="event-details">
                {description}
                <br /><span>{date}<br/>{ timings }</span>
            </div>
            <div className="view-event-div">
                <div className="view-event">
                    <Link to={name}>&lt;~&gt; View Event</Link>
                </div>
            </div>
        </div>
    </>)
}